import React, { useContext } from "react";
import { generateId, IMAGE_TYPE } from "./../../ricos-content";
import { RicosContext, RicosViewerContext } from "./../../ricos-context";
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import classes from "../statics/styles/image-viewer.rtlignore-scss";
import { getExpandFunction } from "./get-expand-function";
import { getImageClickActionConfig } from "./get-image-click-action-config";
import { Image } from "./image";
const ViewerImage = ({
  node,
  nodeIndex,
  NodeViewContainer,
  RicosNodesRenderer
}) => {
  const { config: viewerConfig, seoMode, helpers } = useContext(RicosViewerContext);
  const { isMobile } = useContext(RicosContext);
  const config = viewerConfig[IMAGE_TYPE] ?? {};
  const expand = getExpandFunction({
    helpers,
    config,
    nodeId: node.id,
    imageData: node.imageData
  });
  const imageClickActionConfig = getImageClickActionConfig({
    imageData: node.imageData,
    config,
    expand
  });
  const nodes = node.imageData?.caption && !node.nodes?.length ? [
    {
      type: Node_Type.CAPTION,
      id: generateId(),
      nodes: [
        {
          type: Node_Type.TEXT,
          id: "",
          nodes: [],
          textData: {
            text: node.imageData.caption,
            decorations: []
          }
        }
      ]
    }
  ] : node.nodes ?? [];
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, ({ ContainerElement, SpoilerWrapper, LinkWrapper }) => {
    return /* @__PURE__ */ React.createElement(ContainerElement, null, /* @__PURE__ */ React.createElement("figure", { className: classes.imageFigure }, /* @__PURE__ */ React.createElement(LinkWrapper, null, /* @__PURE__ */ React.createElement(SpoilerWrapper, null, /* @__PURE__ */ React.createElement(
      Image,
      {
        node,
        imageClickActionConfig,
        expand,
        config,
        seoMode,
        helpers,
        isMobile,
        shouldLazyLoadImages: true
      }
    ))), /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes })));
  });
};
const ImageRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(ViewerImage, { key: node.id, node, ...props });
};
var viewer_image_default = ImageRenderer;
export {
  ViewerImage,
  viewer_image_default as default
};
//# sourceMappingURL=viewer-image.js.map

import "@wix/ricos/css/plugin-image-viewer.global.css";